import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
    mostraAlertaError,
    mostraAlertaOk,
} from "../../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import GestionUbicacion from "../../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../../componentes/googlemap/VerUbicacion";
import Page from "../../../componentes/plantilla/Page";
import {
    ClienteImagenEditar,
    ClienteListar,
    ClientesGuardar,
    ImagenCliente,
} from "../../../configuracion/apiUrls";
import { DireccionConfig } from "../../../configuracion/Empresa";
import {
    regexContrasena,
    regexEmail,
    regexIdentidad,
    regexNombre,
    regexNombreVacio,
    regexRTN,
    regexTelefono,
    regexNombreOpcionalValido,
    regexNombreValido
} from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";

const NuevoClienteAuto = () => {
    const { token } = useContextUsuario();
    const { setListaClientes, ActualizarLista } = useContextEmpleado();
    const [nuevaDireccion, setNuevaDireccion] = useState({
        direccion: DireccionConfig.direccion,
        longitud: DireccionConfig.longitud,
        latitud: DireccionConfig.latitud,
    });
    const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [imagen, setImagen] = useState(null);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
    const [showUserData, setShowUserData] = useState(false);
    const [formularioEmpleados, setFormularioEmpleados] = useState({
        id: null,
        correo: "",
        identidad: "",
        rtn: "",
        primerNombre: "",
        segundoNombre: "",
        primerApellido: "",
        segundoApellido: "",
        telefonos: [{ telefono: "" }],
        direcciones: [{ direccion: "", longitud: null, latitud: null }],
        empresas: [{ nombre: "", rtn: "" }],
        genero: null,
        activo: true,
        imagen: "clientes.jpeg",
        contrasena: "",
        nombre: "",
        tipoUsuario: "Cliente",
    });
    const generos = [
        {
            value: 1,
            label: "Masculino",
            otro: "M",
        },
        {
            value: 2,
            label: "Femenino",
            otro: "F",
        },
    ];
    const datos = {
        titulo: {
            titulo: "Nuevo cliente",
            url: "/app/admin/clientes/nuevo",
            tituloUrl: "Clientes",
            nombreUrl: "nuevo",
        },
    };
    const [generoId, setGeneroId] = useState(null);
    const [errorIdentidad, setErrorIdentidad] = useState(false);
    const [errorRtn, setErrorRtn] = useState(false);
    const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
    const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
    const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
    const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
    const [errorCorreo, setErrorCorreo] = useState(false);
    const [errorUsuario, setErrorUsuario] = useState(false);
    const [errorContrasena, setErrorContrasena] = useState(false);
    const [errorConfirmarContrasena, setErrorConfirmarContrasena] = useState(false);
    const [errorTelefonos, setErrorTelefonos] = useState([]);
    const [errorEmpresas, setErrorEmpresas] = useState([]);

    useEffect(() => {
        if (seleccionarDireccion) {
            setIsModalOpen(false);
            //agregarDireccion();
            console.log(formularioEmpleados.direcciones.length);
            setFormularioEmpleados((prevState) => ({
                ...prevState,
                direcciones: [...prevState.direcciones, nuevaDireccion],
            }));
            setSeleccionarDireccion(false);
            //setNuevaDireccion({ direccion: "Dirección: H5V4+2Q2, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras", longitud: -87.84306461526864, latitud: 14.592255371946488 });
        }
    }, [seleccionarDireccion]);

    useEffect(() => {
        setErrorContrasena(!regexContrasena.test(formularioEmpleados.contrasena));
        setErrorPrimerNombre(!regexNombreValido.test(formularioEmpleados.primerNombre));
        setErrorPrimerApellido(!regexNombreValido.test(formularioEmpleados.primerApellido));

        setErrorConfirmarContrasena(
            formularioEmpleados.contrasena !== passwordConfirm
        );
        setErrorUsuario(!regexNombre.test(formularioEmpleados.nombre));
        setErrorCorreo(!regexEmail.test(formularioEmpleados.correo));
        setErrorPrimerNombre(formularioEmpleados.primerNombre.length < 3);
        setErrorPrimerApellido(formularioEmpleados.primerApellido.length < 3);

        const segundoNombre = formularioEmpleados.segundoNombre || '';
        if (segundoNombre.trim()) {
            setErrorSegundoNombre(
                !regexNombreOpcionalValido.test(segundoNombre)
            );
        } else {
            setErrorSegundoNombre(false);
        }

        const segundoApellido = formularioEmpleados.segundoApellido || '';
        if (segundoApellido.trim()) {
            setErrorSegundoApellido(
                !regexNombreOpcionalValido.test(segundoApellido)
            );
        } else {
            setErrorSegundoApellido(false);
        }

        if (formularioEmpleados.rtn) {
            setErrorRtn(!regexRTN.test(formularioEmpleados.rtn));
        } else {
            setErrorRtn(false);
        }

        if (formularioEmpleados.identidad) {
            setErrorIdentidad(!regexIdentidad.test(formularioEmpleados.identidad));
        } else {
            setErrorIdentidad(false);
        }
        const nuevosErrores = formularioEmpleados.telefonos.map((numero) =>
            !regexTelefono.test(numero.telefono)
        );
        setErrorTelefonos(nuevosErrores);
        const nuevosErroresEmpresas = formularioEmpleados.empresas.map(empresa => {
            // Asegurarse de usar formularioEmpleados
            const nombreVacio = (empresa.nombre || '').trim() === "";
            const rtnVacio = (empresa.rtn || '').trim() === "";

            // 1. Inconsistencia (uno lleno y el otro vacío)
            const inconsistencia = (nombreVacio !== rtnVacio);

            // 2. Validación de formato de RTN (si no está vacío)
            const rtnInvalido = !rtnVacio && !regexRTN.test(empresa.rtn || '');

            // 3. Validación de formato de Nombre (si no está vacío, usando regexNombreValido)
            const nombreInvalido = !nombreVacio && !regexNombreValido.test(empresa.nombre || '');

            // Retorna true si hay AL MENOS un error
            return inconsistencia || rtnInvalido || nombreInvalido;
        });
        setErrorEmpresas(nuevosErroresEmpresas);
    }, [formularioEmpleados, passwordConfirm]);

    useEffect(() => {
        var genero = "Masculino"; // Valor por defecto
        if (generoId === 2) genero = "Femenino";
        setFormularioEmpleados({
            ...formularioEmpleados,
            genero: genero,
        });
    }, [generoId]);

    const generarCredenciales = (primerNombre, primerApellido) => {
        
        // Generación de contraseña: 3 letras + 2 números + 1 signo
        // Obtener las 3 primeras letras en minúsculas
        const letrasMin = primerNombre.slice(0, 3).toLowerCase();

        // Convertir la primera letra del primer nombre a mayúscula
        const mayuscula = primerNombre.slice(0, 1).toUpperCase();

        // Las otras dos letras en minúscula
        const otrasLetras = primerNombre.slice(1, 3).toLowerCase();

        // Genera 2 números aleatorios entre 10 y 99
        const numerosAleatorios = Math.floor(10 + Math.random() * 90);

        // Selecciona un símbolo aleatorio
        const simbolos = "!@#$%^&*()_+~`|}{[]:;?><,./-=";
        const simboloAleatorio = simbolos[Math.floor(Math.random() * simbolos.length)];

        // La contraseña final se compone de: Mayúscula + 2 Minúsculas + 2 Números + 1 Símbolo (ej: Axx99@)
        const contrasena = `${mayuscula}${otrasLetras}${numerosAleatorios}${simboloAleatorio}`;

        const usuario = (primerNombre.slice(0, 3) + primerApellido.slice(0, 3)).toLowerCase()+ numerosAleatorios; // Ejemplo: "johdoe42"


        // Generación de correo con dominio gmail.com
        const correo = `${primerNombre.slice(0, 3)}${primerApellido.slice(0, 3) + numerosAleatorios}@gmail.com`.toLowerCase();

        return { usuario, contrasena, correo };
    };

    const manejadorEmpleados = (event) => {
        const { name, value } = event.target;
        setFormularioEmpleados({
            ...formularioEmpleados,
            [name]: value,
        });

        if (name === "primerNombre" || name === "primerApellido") {
            const primerNombre = name === "primerNombre" ? value : formularioEmpleados.primerNombre;
            const primerApellido = name === "primerApellido" ? value : formularioEmpleados.primerApellido;

            if (primerNombre.length >= 3 && primerApellido.length >= 3) {
                const { usuario, contrasena, correo } = generarCredenciales(primerNombre, primerApellido);
                setFormularioEmpleados(prevState => ({
                    ...prevState,
                    nombre: usuario,
                    contrasena: contrasena,
                    correo: correo,
                }));
                setPasswordConfirm(contrasena);
            } else {
                setFormularioEmpleados(prevState => ({
                    ...prevState,
                    nombre: "",
                    contrasena: "",
                    correo: "",
                }));
                setPasswordConfirm("");
            }
        }
    };

    const manejarCambioNumeros = (index, value) => {
        const nuevosNumeros = [...formularioEmpleados.telefonos];
        nuevosNumeros[index] = { telefono: value };

        setFormularioEmpleados({
            ...formularioEmpleados,
            telefonos: nuevosNumeros,
        });
    };

    const agregarNumero = () => {
        setFormularioEmpleados((prevState) => ({
            ...prevState,
            telefonos: [...prevState.telefonos, { telefono: "" }],
        }));
    };

    const eliminarNumero = (index) => {
        setFormularioEmpleados((prevState) => {
            const nuevosNumeros = [...prevState.telefonos];
            nuevosNumeros.splice(index, 1);
            return { ...prevState, telefonos: nuevosNumeros };
        });
    };

    const eliminarDireccion = (index) => {
        setFormularioEmpleados((prevState) => {
            const nuevasDirecciones = [...prevState.direcciones];
            nuevasDirecciones.splice(index, 1);
            return { ...prevState, direcciones: nuevasDirecciones };
        });
    };

    const manejarCambioEmpresas = (index, name, value) => {
        const nuevasEmpresas = [...formularioEmpleados.empresas];
        nuevasEmpresas[index][name] = value;
        setFormularioEmpleados({
            ...formularioEmpleados,
            empresas: nuevasEmpresas,
        });
    };

    const agregarEmpresa = () => {
        setFormularioEmpleados((prevState) => ({
            ...prevState,
            empresas: [...prevState.empresas, { nombre: "", rtn: "" }],
        }));
    };

    const eliminarEmpresa = (index) => {
        setFormularioEmpleados((prevState) => {
            const nuevasEmpresas = [...prevState.empresas];
            nuevasEmpresas.splice(index, 1);
            return { ...prevState, empresas: nuevasEmpresas };
        });
    };

    const BotonGuardar = () => {
        return (
            <>
                <button
                    type="button"
                    className="btn btn-success mr-3"
                    onClick={guardarEmpleado}
                >
                    Guardar
                </button>
                <button
                    type="button"
                    className="btn btn-warning mr-3"
                    onClick={limpiarDatos}
                >
                    Limpiar
                </button>
            </>
        );
    };
    const limpiarDatos = () => {
        setFormularioEmpleados({
            id: null,
            correo: "",
            identidad: "",
            rtn: "",
            primerNombre: "",
            segundoNombre: "",
            primerApellido: "",
            segundoApellido: "",
            telefonos: [{ telefono: "" }],
            direcciones: [{ direccion: "", longitud: null, latitud: null }],
            empresas: [{ nombre: "", rtn: "" }],
            genero: null,
            activo: true,
            imagen: "clientes.jpeg",
            contrasena: "",
            nombre: "",
            tipoUsuario: "Cliente",
        });
        setErrorRtn(false);
        setErrorIdentidad(false);
        setErrorPrimerNombre(false);
        setErrorSegundoNombre(false);
        setErrorPrimerApellido(false);
        setErrorSegundoApellido(false);
        setErrorCorreo(false);
        setErrorUsuario(false);
        setErrorContrasena(false);
        setErrorConfirmarContrasena(false);
        setImagen(null);
        setPasswordConfirm("");
    };

    const quitarCamposVacios = (obj) => {
        return Object.keys(obj).reduce((acc, key) => {
            if (obj[key] !== "" && obj[key] !== null && obj[key] !== undefined) {
                acc[key] = obj[key];
            }
            return acc;
        }, {});
    };

    const guardarEmpleado = async () => {
        const hayErrorTelefonos = errorTelefonos.some(e => e);
        const hayErrorEmpresas = errorEmpresas.some(e => e);
        if (
            errorIdentidad ||
            errorRtn ||
            errorPrimerNombre ||
            errorSegundoNombre ||
            errorPrimerApellido ||
            errorSegundoApellido ||
            errorCorreo ||
            errorUsuario ||
            errorContrasena ||
            hayErrorTelefonos ||
            hayErrorEmpresas ||
            errorConfirmarContrasena
        ) {
            mostraAlertaError("Existen errores en los datos");
        } else {
            try {
                const direccionesVacia = formularioEmpleados.direcciones.filter(
                    (f) => f.direccion !== "" || f.longitud !== null || f.latitud !== null
                );
                const telefonosVacia = formularioEmpleados.telefonos.filter(
                    (f) => f.telefono !== "" || f.telefono !== null
                );
                const empresasValidas = formularioEmpleados.empresas.filter(empresa =>
                    (empresa.nombre || '').trim() !== "" || (empresa.rtn || '').trim() !== ""
                );
                const datos = {
                    ...formularioEmpleados,
                    empresas: empresasValidas,
                    direcciones: direccionesVacia,
                    telefonos: telefonosVacia,
                };
                const nuevosDatos = quitarCamposVacios(datos, ['rtn', 'identidad', 'segundoNombre', 'segundoApellido']);
                await AxiosPrivado.post(ClientesGuardar, nuevosDatos)
                    .then(async (respuesta) => {
                        console.log(respuesta);
                        await guardarImagen(respuesta.data.id);
                        limpiarDatos();
                        ActualizarLista(ClienteListar, setListaClientes);
                        mostraAlertaOk("Cliente guardado correctamente");
                    })
                    .catch((er) => {
                        const { response } = er;
                        const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                console.log(error);
                mostraAlertaError("Error al guardar el empleado");
            }
        }
    };

    const guardarImagen = async (empleadoId) => {
        if (!imagen) {
            return;
        } else {
            try {
                await AxiosImagen.put(ClienteImagenEditar + empleadoId, imagen)
                    .then((respuesta) => {
                        console.log(respuesta);
                        setFormularioEmpleados((prevState) => ({
                            ...prevState,
                            imagen: respuesta.data.imagen,
                        }));
                        mostraAlertaOk("Imagen actualizada correctamente");
                    })
                    .catch((er) => {
                        const { response } = er;
                        const msjError = response?.data?.msj || response?.data?.error?.message || "Ocurrió un error desconocido.";
                        mostraAlertaError(msjError, "error");
                    });
            } catch (error) {
                console.log(error);
                mostraAlertaError("Error al actualizar la imagen");
            }
        }
    };
    const handleFileChange = async (event) => {
        const fileObj = event.target.files && event.target.files[0];
        if (!fileObj) {
            return;
        } else {
            try {
                let formData = new FormData();
                formData.append("imagen", event.target.files[0]);
                setImagen(formData);
                mostraAlertaOk("Imagen seleccionada correctamente");
            } catch (error) {
                console.log(error);
                mostraAlertaError("Error al actualizar la imagen");
            }
        }
    };

    const SeleccionarImagen = () => {
        console.log("Haciendo clic en SeleccionarImagen");
        if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const inputRef = useRef(null);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };
    const togglePasswordVisibilityConfirm = () => {
        setShowPasswordConfirm(!showPasswordConfirm);
    };

    return (
        <Page datos={datos}>
            <div className="row">
                <div className="col-12">
                    <Card titulo="Datos del cliente" pie={<BotonGuardar />}>
                        <h5>Datos generales</h5>
                        <hr></hr>
                        {/*Imagen*/}
                        <div className="row">
                            <div className="col-sm-4 col-lg-2">
                                <div className="form-group">
                                    <div className="text-center">
                                        <img
                                            className="product-image"
                                            src={ImagenCliente + formularioEmpleados.imagen}
                                            alt="Foto"
                                            crossOrigin="anonymous"
                                        />
                                    </div>
                                    <input
                                        type="file"
                                        style={{ display: "none" }}
                                        ref={inputRef}
                                        onChange={handleFileChange}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-block btn-outline-info btn-xs"
                                        onClick={SeleccionarImagen}
                                    >
                                        Agregar
                                    </button>
                                </div>
                            </div>

                            {/**Nombre */}

                            <div className="col-sm-8 col-lg-10">
                                <div className="row">
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorRtn ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Ingrese el rtn"
                                                name="rtn"
                                                value={formularioEmpleados.rtn}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorRtn && (
                                                <div className="invalid-feedback">
                                                    El RTN debe tener exactamente 14 dígitos.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorIdentidad ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Ingrese la identidad"
                                                name="identidad"
                                                value={formularioEmpleados.identidad}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorIdentidad && (
                                                <div className="invalid-feedback">
                                                    La identidad debe tener exactamente 13 dígitos.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Primer Nombre"
                                                name="primerNombre"
                                                value={formularioEmpleados.primerNombre}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorPrimerNombre && (
                                                <div className="invalid-feedback">
                                                    El primer nombre debe tener al menos 3 caracteres (se permiten tildes)..
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-sm-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Segundo Nombre"
                                                name="segundoNombre"
                                                value={formularioEmpleados.segundoNombre}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorSegundoNombre && (
                                                <div className="invalid-feedback">
                                                    El segundo nombre debe tener al menos 3 caracteres (se permiten tildes)..
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Primer Apellido"
                                                name="primerApellido"
                                                value={formularioEmpleados.primerApellido}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorPrimerApellido && (
                                                <div className="invalid-feedback">
                                                    El primer apellido debe tener al menos 3 caracteres (se permiten tildes)..
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-sm-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                                                    }`}
                                                id="text"
                                                placeholder="Segundo Apellido"
                                                name="segundoApellido"
                                                value={formularioEmpleados.segundoApellido}
                                                onChange={manejadorEmpleados}
                                            />
                                            {errorSegundoApellido && (
                                                <div className="invalid-feedback">
                                                    El segundo apellido debe tener al menos 3 caracteres (se permiten tildes)..
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Empresas */}
                        <h5>Datos de la empresas</h5>
                        <hr></hr>
                        <div className="row mb-3">
                            <div className="col-sm-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarEmpresa}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            {formularioEmpleados.empresas.map((empresa, index) => (
                                <div key={index} className="col-md-6 mb-3">
                                    <div className="input-group">
                                        <input
                                            type="text"
                                            className={`form-control ${errorEmpresas[index] ? "is-invalid" : ""}`}
                                            placeholder="Nombre de la empresa"
                                            name="nombre"
                                            value={empresa.nombre}
                                            onChange={(event) =>
                                                manejarCambioEmpresas(index, "nombre", event.target.value)
                                            }
                                        />
                                        <input
                                            type="text"
                                            className={`form-control ${errorEmpresas[index] ? "is-invalid" : ""}`}
                                            placeholder="RTN de la empresa"
                                            name="rtn"
                                            value={empresa.rtn}
                                            onChange={(event) =>
                                                manejarCambioEmpresas(index, "rtn", event.target.value)
                                            }
                                        />
                                        {formularioEmpleados.empresas.length > 1 && (
                                            <div className="input-group-append">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={() => eliminarEmpresa(index)}
                                                >
                                                    <i className="fa fa-minus" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        )}
                                    </div>
                                    {(empresa.nombre || '').trim() !== "" && (empresa.rtn || '').trim() === "" && (
                                        <div className="invalid-feedback d-block">
                                            Debe ingresar el RTN si especifica el nombre de la empresa.
                                        </div>
                                    )}
                                    {(empresa.nombre || '').trim() !== "" && !regexNombreValido.test(empresa.nombre) && (
                                        <div className="invalid-feedback d-block">
                                            El nombre debe tener un mínimo de 3 caracteres (se permiten tildes).
                                        </div>
                                    )}

                                    {(empresa.rtn || '').trim() !== "" && (empresa.nombre || '').trim() === "" && (
                                        <div className="invalid-feedback d-block">
                                            Debe ingresar el nombre de la empresa si especifica el RTN.
                                        </div>
                                    )}
                                    {(empresa.rtn || '').trim() !== "" && !regexRTN.test(empresa.rtn) && (
                                        <div className="invalid-feedback d-block">
                                            El RTN debe tener exactamente 14 dígitos numéricos.
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        {/**Datos del usuario */}
                        <div className="d-flex justify-content-between align-items-center">
                            <h5>Datos del usuario</h5>
                            <button
                                type="button"
                                className="btn btn-link"
                                onClick={() => setShowUserData(!showUserData)}
                            >
                                <i className={`fa fa-${showUserData ? 'minus' : 'plus'}`} aria-hidden="true"></i>
                            </button>
                        </div>
                        <hr></hr>
                        {showUserData && (
                            <>
                                <div className="row">
                                    <div className="col-sm-12 col-lg-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className={`form-control ${errorCorreo ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Ingrese el correo"
                                                name="correo"
                                                value={formularioEmpleados.correo}
                                                onChange={manejadorEmpleados}
                                                autoComplete="off"
                                            />
                                            {errorCorreo && (
                                                <div className="invalid-feedback">
                                                    Correo electrónico inválido
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-sm-12 col-lg-6">
                                        <div className="input-group mb-3">
                                            <input
                                                type="text"
                                                className={`form-control ${errorUsuario ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Nombre de usuario"
                                                value={formularioEmpleados.nombre}
                                                onChange={manejadorEmpleados}
                                                name="nombre"
                                                autoComplete="off"
                                            />
                                            <div className="input-group-append">
                                                <div className="input-group-text">
                                                    <span className="fas fa-user"></span>
                                                </div>
                                            </div>
                                            {errorUsuario && (
                                                <div className="invalid-feedback">
                                                    El nombre de usuario debe tener al menos 3 caracteres.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-lg-6">
                                        <div className="input-group mb-3">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                placeholder="Contraseña"
                                                className={`form-control ${errorContrasena ? "is-invalid" : ""
                                                    }`}
                                                value={formularioEmpleados.contrasena}
                                                onChange={manejadorEmpleados}
                                                name="contrasena"
                                                autoComplete="off"
                                            />

                                            <div className="input-group-append">
                                                <div
                                                    className="input-group-text"
                                                    onClick={togglePasswordVisibility}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <span
                                                        className={
                                                            showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {errorContrasena && (
                                                <div className="invalid-feedback">
                                                    La contraseña debe tener exactamente 6 caracteres.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-lg-6">
                                        <div className="input-group mb-3">
                                            <input
                                                type={showPasswordConfirm ? "text" : "password"}
                                                className={`form-control ${errorConfirmarContrasena ? "is-invalid" : ""
                                                    }`}
                                                placeholder="Confirmar Contraseña"
                                                value={passwordConfirm}
                                                onChange={(e) => setPasswordConfirm(e.target.value)}
                                            />

                                            <div className="input-group-append">
                                                <div
                                                    className="input-group-text"
                                                    onClick={togglePasswordVisibilityConfirm}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <span
                                                        className={
                                                            showPasswordConfirm
                                                                ? "fas fa-eye-slash"
                                                                : "fas fa-eye"
                                                        }
                                                    ></span>
                                                </div>
                                            </div>
                                            {errorConfirmarContrasena && (
                                                <div className="invalid-feedback">
                                                    Las contraseñas no coinciden.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/*Numeros de telefonos */}
                        <h5>Teléfonos</h5>
                        <hr></hr>
                        <div className="row mb-3">
                            <div className="col-sm-3">
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={agregarNumero}
                                >
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            {formularioEmpleados.telefonos.map((numero, index) => (
                                <div
                                    key={index}
                                    className="input-group col-sm-12 col-md-6 mb-3"
                                >
                                    <input
                                        type="text"
                                        className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                                        placeholder="Ej: 98908767"
                                        name="telefono"
                                        value={numero.telefono}
                                        onChange={(event) =>
                                            manejarCambioNumeros(index, event.target.value)
                                        }
                                    />
                                    {formularioEmpleados.telefonos.length >= 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-danger mx-3"
                                            onClick={() => eliminarNumero(index)}
                                            width="20px"
                                        >
                                            <i className="fa fa-minus" aria-hidden="true"></i>
                                        </button>
                                    )}
                                    {errorTelefonos[index] && (
                                        <div className="invalid-feedback">
                                            Número inválido. Debe tener entre 8 y 12 dígitos.
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        {/*Direcciones */}
                        <h5>Direcciones</h5>
                        <hr></hr>
                        <div className="row">
                            <div className="col-12">
                                <div className="pb-3">
                                    <GestionUbicacion
                                        direccion={nuevaDireccion}
                                        setDireccion={setNuevaDireccion}
                                        isModalOpen={isModalOpen}
                                        setIsModalOpen={setIsModalOpen}
                                        setSeleccionarDireccion={setSeleccionarDireccion}
                                        textoBoton={"Agregar Ubicación"}
                                        verdireccion={false}
                                    />
                                </div>
                            </div>
                        </div>
                        {/**Direcciones */}
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    {formularioEmpleados.direcciones
                                        .filter(f => f.direccion && f.latitud && f.longitud)
                                        .map((f, index) => (
                                            <div key={index} className="row">
                                                <div className="col-9">
                                                    <p className="text-muted">{f.direccion}</p>
                                                </div>
                                                <div className="col-3">
                                                    <VerUbicacion direccion={f} />
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger"
                                                        onClick={() => eliminarDireccion(index)}
                                                    >
                                                        <i className="fa fa-minus" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                        {/**Genero y Estado en una sola fila */}
                        <hr></hr>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <select
                                        className="form-control w-50"
                                        style={{ width: "100%" }}
                                        value={generoId || ""}
                                        onChange={(e) => setGeneroId(e.target.value)}
                                    >
                                        <option value="">Seleccione el género</option>
                                        {generos.map((genero) => (
                                            <option key={genero.value} value={genero.value}>
                                                {genero.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="form-group">
                                    <div className="custom-control custom-switch custom-switch-off-danger custom-switch-on-success">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="customSwitch3"
                                            name="activo"
                                            checked={formularioEmpleados.activo}
                                            onChange={(event) => {
                                                setFormularioEmpleados({
                                                    ...formularioEmpleados,
                                                    activo: event.target.checked,
                                                });
                                            }}
                                        />
                                        <label
                                            className="custom-control-label"
                                            htmlFor="customSwitch3"
                                        >
                                            {formularioEmpleados.activo ? "Activo" : "Inactivo"}
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        </Page>
    );
};

export default NuevoClienteAuto;